import { call, put, select } from "redux-saga/effects";
import { getAllItem } from "@gcloud-npm/adabyron.catalogue.get-all-item";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import { CQ_ACTION_CODES, CQ_POTS, FUNDED_TYPES, IVA, SHOPPING_CART } from "../catalogConstants";
import { WEB_SERVICES } from "./webServices";
import { FLOW_TYPES } from "../flowDefinition/flowTypes";
import { DEVICE_VALUES, PRODUCT_TYPES } from "../utils/catalog";

const contextStore = (state) => state.context.data;
const offerStore = (state) => state.offer;

const normalizeFundedMethod = (fundedMethod) => {
  let selectedMethod;
  switch (fundedMethod) {
    case FUNDED_TYPES.FUNDED:
      selectedMethod = CQ_POTS.PAYMENT_POT.FUNDED;
      break;
    case FUNDED_TYPES.FUNDED_NO_TAXES:
      selectedMethod = CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES;
      break;
    case FUNDED_TYPES.FUNDED_SPECIAL_TAXES:
      selectedMethod = CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES;
      break;
    default:
      break;
  }
  return selectedMethod;
};

/**
 * Esta función normaliza los datos de un artículo.
 *
 * @param {object} data - Los datos del artículo.
 * @param {string} colorId - El ID del color.
 * @param {string} storageId - El ID del almacenamiento.
 * @param {number} months - La cantidad de meses.
 * @returns {object} Los datos normalizados del artículo.
 */

export const normalizeGetTerminalData = (
  data,
  productOffering,
  colorId,
  storageId,
  isSelfEmployedFlow,
  flowName,
  r2rType,
  useCatalogPrice
) => {
  const { products } = data;
  const itemData = {
    name: null,
    fundingOfferInfo: null,
    imageUrl: null,
    color: null,
    storage: null,
    clientPrice: null,
    isPrePurchase: false,
    oneTimeCharge: null,
    swapRenewalPeriod: null,
  };

  if (!products || !Array.isArray(products) || products.length === 0) {
    const frontSonda = new FrontSonda({
      processName: "normalizeGetTerminalData",
      filePath: "bitSagas/getTerminalData",
    });
    const flow = `${flowName}_${r2rType ? r2rType : ""}`;
    frontSonda.severalMessage({
      info: `No se ha obtenido ningun producto del api getAllItem en el flujo de compra ${flow} con el productOffering ${productOffering}, capacidad ${storageId} y color ${colorId}. Sólo debe venir uno`,
    });
  } else if (products.length > 1) {
    const frontSonda = new FrontSonda({
      processName: "normalizeGetTerminalData",
      filePath: "bitSagas/getTerminalData",
    });
    const flow = `${flowName}_${r2rType ? r2rType : ""}`;
    frontSonda.severalMessage({
      info: `Se ha obtenido más de un producto del api getAllItem en el flujo de compra ${flow} con el productOffering ${productOffering}, capacidad ${storageId} y color ${colorId}. Sólo debe venir uno`,
    });
  } else {
    const product = products[0];
    // Recorre todos los productos
    const { offers, warehouse } = product; // Obtiene la propiedad offers de cada producto
    
    if(warehouse === 'LBMpeninsula'){
      itemData.isWhiteGood = true;
    }
    
    let offersArray = [];

    if (
      offers.libre &&
      Array.isArray(offers.libre) &&
      flowName === FLOW_TYPES.DEVICES
    ) {
      offersArray = offers.libre;
    } else if (
      offers.r2r &&
      Array.isArray(offers.r2r) &&
      (flowName === FLOW_TYPES.R2R || flowName === FLOW_TYPES.R2R_RENEWAL || flowName === FLOW_TYPES.R2R_AUTO_RENEWAL || flowName === FLOW_TYPES.R2R_2) &&
      r2rType === DEVICE_VALUES.INCLUDED
    ) {
      offersArray = offers.r2r;
    } else if (
      offers.r2rAdditional &&
      Array.isArray(offers.r2rAdditional) &&
      (flowName === FLOW_TYPES.R2R || flowName === FLOW_TYPES.R2R_2) &&
      r2rType === DEVICE_VALUES.ADDITIONAL
    ) {
      offersArray = offers.r2rAdditional;
    }
    if (
      !offersArray ||
      !Array.isArray(offersArray) ||
      offersArray.length === 0
    ) {
      const frontSonda = new FrontSonda({
        processName: "normalizeGetTerminalData",
        filePath: "bitSagas/getTerminalData",
      });
      const flow = `${flowName}_${r2rType ? r2rType : ""}`;
      frontSonda.severalMessage({
        info: `No se ha obtenido ninguna oferta del api getAllItem en el flujo de compra ${flow} con el productOffering ${productOffering}, capacidad ${storageId} y color ${colorId}. Sólo debe venir uno`,
      });
    } else if (offersArray.length > 1) {
      const frontSonda = new FrontSonda({
        processName: "normalizeGetTerminalData",
        filePath: "bitSagas/getTerminalData",
      });
      const flow = `${flowName}_${r2rType ? r2rType : ""}`;
      frontSonda.severalMessage({
        info: `Se ha obtenido más de una oferta del api getAllItem en el flujo de compra ${flow} con el productOffering ${productOffering}, capacidad ${storageId} y color ${colorId}. Sólo debe venir uno`,
      });
    } else {
      const offer = offersArray[0];

      const {
        urlNewFicha,
        productSpecs,
        fundingOfferInfo,
        tipo_financiacion,
        imgs,
        name,
        productOffering: pacProductOffering,
        colorName,
        storage,
        clientPrice,
        pvpTotalUntaxed,
        isPrecompra,
        tradeIn,
        currentPrice,
        tags,
        swapRenewalPeriod,
      } = offer;

      let { financialEndDate } = offer;
      if (!financialEndDate) {
        financialEndDate = new Date().toLocaleDateString();
      }
      if (productSpecs) {
        const { storage: storageIdOffer, color: colorIdOffer } = productSpecs;
        if (
          colorIdOffer === colorId &&
          storageIdOffer === storageId &&
          pacProductOffering === productOffering
        ) {
          itemData.name = name;
          itemData.color = colorName;
          itemData.storage = storage;
          itemData.clientPrice = clientPrice;
          itemData.pvpUntaxed = pvpTotalUntaxed;
          itemData.isPrePurchase = isPrecompra;
          itemData.fileUrl = urlNewFicha;
          itemData.swap = false;
          itemData.swapRenewalPeriod = swapRenewalPeriod;
          if(Array.isArray(tags) && tags.some(tag => tag.toLowerCase().includes('swap'))){
            itemData.swap = true;
          }
          if(useCatalogPrice){
            itemData.pricesInfo = {
              recurringCharges: {},
              oneTimeCharges: {
                products: [
                  {
                    productOffering: {
                      id: productOffering,
                      text: name,
                    },
                    promotionId: null,
                    promotionText: '',
                    priceBeforeDiscounts: null,
                    actionId: CQ_ACTION_CODES.BUY,
                    clientPhoneNumberToBeAppliedTo: null,
                    finalPrice: currentPrice,
                    taxName: IVA,
                    productType: PRODUCT_TYPES.VTL
                  }
                ],
                groupPrice: currentPrice
              },
              taxName: IVA,
              haveMaintainingPromo: false,
              termsAndConditions: ""
            }
          }
          if (Array.isArray(imgs) && imgs.length > 0) {
            itemData.imageUrl = imgs[0];
          }
          const fundedMethodType = normalizeFundedMethod(tipo_financiacion);
          if (
            fundingOfferInfo &&
            Array.isArray(fundingOfferInfo) &&
            fundingOfferInfo.length > 0 &&
            !isSelfEmployedFlow
          ) {
            const sortedFundingOffers = fundingOfferInfo.sort(
              (a, b) => a.months - b.months
            );
            itemData.fundingOfferInfo = {
              fundingOffers: sortedFundingOffers,
              fundedMethodType,
              financialEndDate,
            };
          }
          if (
            tradeIn &&
            tradeIn.thankyoupageDesc &&
            tradeIn.endDate
          ) {
            itemData.tradeIn = {
              description: tradeIn.thankyoupageDesc,
              endDate: tradeIn.endDate,
            }
          }
        } else {
          const frontSonda = new FrontSonda({
            processName: "normalizeGetTerminalData",
            filePath: "bitSagas/getTerminalData",
          });
          const flow = `${flowName}_${r2rType ? r2rType : ""}`;
          frontSonda.severalMessage({
            info: `Se ha obtenido una oferta incorrecta del api getAllItem en el flujo de compra ${flow} con el productOffering ${productOffering}, capacidad ${storageId} y color ${colorId}`,
          });
        }
      }
    }
  }
  return itemData;
};

export function* getTerminalData(params) {
  const { productOffering, color, storage, r2rType, isSelfEmployedFlow, flowName, useCatalogPrice, reduxUpdate, normalizeHttpErrors } =
    params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const params = {
      context,
      po: productOffering,
      colorId: color,
      storageId: storage,
      Urlfilters: '&minStock=0',
    };
    const response = yield call(getAllItem, params);
    
    const responseNormalized = normalizeGetTerminalData(
      response,
      productOffering,
      color,
      storage,
      isSelfEmployedFlow,
      flowName,
      r2rType,
      useCatalogPrice,
    );

    yield put(successUpdate(responseNormalized));
    return responseNormalized;
  } catch (error) {
    console.log("Saga error: ", error);
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.GET_ALL_ITEM,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
